console.log("🔧 UpCart collection handler active");
console.log("▶ Found triggers:", document.querySelectorAll('.productitem--action-trigger').length);

document.addEventListener('DOMContentLoaded', () => {
  document.body.addEventListener('click', async (e) => {
    const btn = e.target.closest('.productitem--action-trigger');
    if (!btn) return;
    e.preventDefault();

    const variantId = btn.dataset.variantId;
    const quantity  = btn.dataset.quantity || 1;
    if (!variantId) {
      console.error('⚠️ No data-variant-id found on trigger');
      return;
    }

    // 1) Add to Shopify
    try {
      const addRes = await fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          'Accept': 'application/json'
        },
        body: `id=${variantId}&quantity=${quantity}`
      });
      if (!addRes.ok) throw new Error(`Add failed (${addRes.status})`);
      console.log('✅ Added variant', variantId, '×', quantity);
    } catch (err) {
      console.error('❌ Add-to-cart error:', err);
      return;
    }

    // 2) Grab the full updated cart
    let cart;
    try {
      const cartRes = await fetch('/cart.js', {
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' }
      });
      cart = await cartRes.json();
      console.log('📦 Fetched full cart:', cart);
    } catch (err) {
      console.error('❌ Failed to fetch /cart.js:', err);
      // we’ll still try to open the drawer below
    }

    // 3) Feed it into UpCart’s loader (so the UI shows the correct items) :contentReference[oaicite:0]{index=0}
    if (cart && typeof window.upcartOnCartLoaded === 'function') {
      try {
        window.upcartOnCartLoaded(cart);
      } catch (e) {
        console.warn('⚠️ upcartOnCartLoaded threw:', e);
      }
    }

    // 4) Finally open the drawer
    if (typeof window.upcartOpenCart === 'function') {
      window.upcartOpenCart();
    } else {
      console.error('❌ upcartOpenCart() not found');
    }
  });
});

